<template>
  <!-- 案件详情-摘要记录（审核记录、沟通记录、客诉记录） -->
  <div class="summaryRecord-block">
    <el-tabs type="border-card" stretch>
      <el-tab-pane v-if="checkPermission('审核摘要:查看', permList)" label="审核记录">
        <template
          v-if="
            (trialData['1000'] && trialData['1000'].length) ||
              (trialData['1015'] && trialData['1015'].length)
          "
        >
          <!-- 初审 -->
          <h6 class="title-block bold">初审摘要</h6>
          <!-- 时间线-内容 -->
          <v-time-line :list-data="trialData['1000']" />

          <!-- 复审 -->
          <h6 class="title-block bold">复审摘要</h6>
          <!-- 时间线-内容 -->
          <v-time-line :list-data="trialData['1015']" />
        </template>
        <!-- 空状态-组件 -->
        <v-null-custom v-else />
      </el-tab-pane>
      <el-tab-pane v-if="checkPermission('沟通摘要:查看', permList)" label="沟通记录">
        <template v-if="communicateList.length">
          <!-- 时间线-内容 -->
          <v-time-line :list-data="communicateList" />
        </template>
        <!-- 空状态-组件 -->
        <v-null-custom v-else />
      </el-tab-pane>
      <el-tab-pane v-if="checkPermission('客诉摘要:查看', permList)" label="客诉记录">
        <!-- 客诉记录基础信息 -->
        <v-appeals-descriptions :data="appeals" />

        <div class="timeline-content">
          <h3 class="timeline-title bold">摘要</h3>
          <template v-if="lawList.length">
            <!-- 时间线-内容 -->
            <v-time-line :list-data="lawList" />
          </template>
          <!-- 空状态-组件 -->
          <v-null-custom v-else />
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="checkPermission('法务摘要:查看', permList)" label="法务记录">
        <!-- 法务记录基础信息 -->
        <v-legal-descriptions :data="legalAffairs" />

        <div class="timeline-content">
          <h3 class="timeline-title bold">摘要</h3>
          <template v-if="legalAffairList.length">
            <!-- 时间线-内容 -->
            <v-time-line :list-data="legalAffairList" />
          </template>
          <!-- 空状态-组件 -->
          <v-null-custom v-else />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TimeLine from './timeline.vue' // 时间线-组件
import NullCustom from './nullCustom.vue' // 空状态-组件
import AppealsDescriptions from './appealsDescriptions.vue' // 客诉记录基础信息-组件
import LegalDescriptions from './legalDescriptions.vue' // 法务记录基础信息-组件

export default {
  name: 'SummaryRecord',

  components: {
    'v-time-line': TimeLine,
    'v-null-custom': NullCustom,
    'v-appeals-descriptions': AppealsDescriptions,
    'v-legal-descriptions': LegalDescriptions
  },

  props: {
    // 审核摘要
    trialData: {
      type: Object,
      default: () => {}
    },
    // 沟通摘要
    communicateList: {
      type: Array,
      default: () => []
    },
    // 客诉摘要
    lawList: {
      type: Array,
      default: () => []
    },
    // 法务摘要
    legalAffairList: {
      type: Array,
      default: () => []
    },
    // 客诉记录基础信息
    appeals: {
      type: Object,
      default: () => {}
    },
    // 法务记录基础信息
    legalAffairs: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList
    })
  }
}
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>
